<page-header title="როლების სია">
    <button mat-icon-button class="add-button" aria-label="add" (click)="add()">
        <mat-icon>add</mat-icon>
    </button>
</page-header>

<mat-action-list>
    @for (role of roles; track role._id) {
        <button mat-list-item (click)="edit(role)">
            <span matListItemTitle>{{ role.name }}</span>
            <span matListItemLine>{{ role.description }}</span>
            <mat-icon matListItemMeta>edit</mat-icon>
        </button>
    } @empty {
        <div class="empty-state">როლები არ მოიძებნა</div>
    }
</mat-action-list>
